/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC } from 'react'
import { Avatar } from '@mui/material'
import * as teamMembersClasses from 'pagesNew/TeamMembers/TeamMembersPlatformList/styles'
import { findAllDentalSchools_findAllDentalSchool_items as DentalSchool } from '__generatedTypes__/findAllDentalSchools'
import * as classes from 'pagesNew/OrginizeBlogPages/OrganizeCreateSuccessStory/Form/SuccessStoriesFieldArray/styles'

type Props = {
  dentalSchool: DentalSchool
}

export const DentalSchoolRenderItem: FC<Props> = ({ dentalSchool }) => (
  <div css={teamMembersClasses.renderItem}>
    <div css={teamMembersClasses.block}>
      <div css={teamMembersClasses.avatar}>
        <Avatar src={dentalSchool.getCoverImage || ''} css={teamMembersClasses.avatar} alt="Dental School cover" />
      </div>
      <Typography variant="body2" css={[teamMembersClasses.longText, classes.longText]}>
        {dentalSchool.title}
      </Typography>
    </div>
  </div>
)
